import planeRight from "../assets/paperPlaneright.png"
import planeLeft from "../assets/paperPlaneleft.png"
import "./PaperPlanes.css"

const PaperPlanes = () => {

    return(
        <>
            <img src={planeLeft} alt="" id="planeLeft"/>
            <img src={planeRight} alt="" id="planeRight"/>
        </>
        
    )
}

export default PaperPlanes